import { ReactNode, useState, useRef, useEffect } from "react";
import { cn } from "@/utils/cn";

interface PopoverProps {
    trigger: ReactNode;
    children: ReactNode;
    className?: string;
}

export const Popover = ({ trigger, children, className }: PopoverProps) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="relative" ref={ref}>
            <div onClick={() => setOpen((prev) => !prev)}>{trigger}</div>
            {open && (
                <div
                    key={open ? 'open' : 'closed'}
                    className={cn(
                        "absolute z-50 mt-2 min-w-64 rounded-md border bg-white p-4 shadow-xl dark:bg-gray-800",
                        className
                    )}
                >
                    {children}
                </div>
            )}
        </div>
    );
};
